import { FooterContainer, FooterContent, FooterSection, SocialLinks } from './styles';
import { FaFacebook, FaTwitter, FaLinkedin, FaEnvelope } from 'react-icons/fa';

const Footer = () => {
  return (
    <FooterContainer>
      <FooterContent>
        <FooterSection>
          <h3>CODHOD asbl</h3>
          <p>Comité des droits de l'homme et développement</p>
          <SocialLinks>
            <a href="https://web.facebook.com/profile.php?id=61577266572980"><FaFacebook /></a>
            {/* <a href="#"><FaTwitter /></a>
            <a href="#"><FaLinkedin /></a> */}
            <a href="mailto:contact@codhod.org"><FaEnvelope /></a>
          </SocialLinks>
        </FooterSection>
        <FooterSection>
          <h4>Contact</h4>
          <p>Email: contact@codhod.org</p>
          <p>Téléphone: (+243) 998 187 483 - 998 211 469 - 816 869 438</p>
          <p>79 AV/Kalembelembe Q/Aketi C/Kinshasa<br />Kinshasa, RDC</p>
        </FooterSection>
        <FooterSection>
          <h4>Liens rapides</h4>
          <ul>
            <li><a href="/about">À propos</a></li>
            <li><a href="/programs">Programmes</a></li>
            <li><a href="/news">Actualités</a></li>
            <li><a href="/contact">Contact</a></li>
          </ul>
        </FooterSection>
      </FooterContent>
    </FooterContainer>
  );
};

export default Footer;